<template>
  <div class="d-inline-block">
    <button :class="buttonCssClass" @click.prevent="markGuideRead" :disabled="read">
      <i :class="['fa-fw mr-1', isRead ? 'fa fa-check' : 'far fa-circle' ]"></i>
      {{ isRead ? "You've Read This" : "Mark as Read" }}
    </button>
    <celebration v-model="celebrateMarkAsRead" :show-confetti="false">
      <div class="p-4 p-md-5">
        <p class="h4 mb-3">Awesome! We hope you learned a lot from
          <b>{{ guide.title}}</b></p>
        <p>Ready to move onto the next guide on the trail?
          Just click <b>Next Guide</b>. Need to take a break?
          That's OK! Just come back to Support Center anytime
          to keep exploring this trail.</p>
      </div>
      <div slot="modal-footer">
        <div class="d-flex">
          <button class="btn btn-flat-wisteria mr-auto" @click.prevent="goToNextGuide">
            Next Guide<span v-if="waitTime > -1"> in {{ waitTime }}s</span>
            <i class="fa fa-arrow-right ml-1"></i>
          </button>
          <a href="/support" class="btn btn-link text-body text-decoration-none">
            Take a break
          </a>
        </div>
      </div>
    </celebration>
    <celebration v-model="celebrateCompletedTrail" :show-confetti="true" :dismissable="false">
      <div class="p-4 p-md-5">
        <p class="h4 mb-3">Amazing! You've finished
          <b>{{ trail.title}}</b> in record time.</p>
        <p>Now the choice is yours: you can go out
          and apply your new know-how, or you can start
          another trail. The world is your oyster.</p>
      </div>
      <div slot="modal-footer">
        <div class="d-flex">
          <a href="/support/trails" class="btn btn-flat-wisteria mr-2">
            <i class="fa fa-map-signs mr-1"></i>
            Browse Trails
          </a>
          <a href="/" class="btn btn-link text-body text-decoration-none">
            or exit Support Center
          </a>
        </div>
      </div>
    </celebration>
  </div>
</template>

<script>
import { markGuideRead } from '@/api'
import Celebration from './Celebration'
import alertify from 'alertify.js'

export default {
  components: {
    Celebration
  },
  props: {
    cssClass: {
      type: [String, Array],
      default () {
        return 'btn text-nowrap btn-flat-wisteria'
      }
    },
    guide: {
      type: Object,
      required: true
    },
    read: {
      default: null
    }
  },
  data () {
    return {
      readState: this.read,
      celebrateMarkAsRead: false,
      celebrateCompletedTrail: false,
      trail: {},
      nextGuide: {},
      waitTime: 30,
      waitInterval: null
    }
  },
  computed: {
    buttonCssClass () {
      return this.cssClass
    },
    isRead () {
      return !!this.read
    }
  },
  watch: {
    waitTime (value) {
      if (this.waitTime < 0) {
        clearInterval(this.waitInterval)
        this.goToNextGuide()
      }
    }
  },
  mounted () {
    $('body').prepend($(this.$el).find('.celebration'))
  },
  methods: {
    async markGuideRead () {
      try {
        let { data } = await markGuideRead(this.guide)
        this.trail = data.trail
        if ('completed' === data.session) {
          this.celebrateCompletedTrail = true
        } else {
          this.nextGuide = data.nextGuide
          this.celebrateMarkAsRead = true
          this.waitInterval = setInterval(() => {
            this.waitTime--
          }, 1000)

        }
      } catch (e) {
        alertify.error("Oops! We had a problem marking that Guide as read. Please try again.")
      }
    },
    goToNextGuide () {
      document.location = this.nextGuide.link
    }
  }
}
</script>